export default __webpack_public_path__ + "static/media/refresh.9a5861a4.svg";